import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "../Navbar2/logo.png";

// TEAM IMAGES
import Amol from "../../views/OurTeam/Amol.jpeg";
import Amit from "../../views/OurTeam/amit.png";
import jitendra from "../../views/OurTeam/jitendra.jpg";
import sarang from "../../views/OurTeam/sarang sir.jpg";
import sammer from "../../views/OurTeam/sammer.jpeg";

import img1 from "../Cleints/images/img1.png";
import img2 from "../Cleints/images/img2.png";
import img3 from "../Cleints/images/img3.png";
import img4 from "../Cleints/images/img4.png";
import img5 from "../Cleints/images/img5.png";
import img6 from "../Cleints/images/img6.png";
import img7 from "../Cleints/images/img7.png";
import img8 from "../Cleints/images/img8.png";
import img9 from "../Cleints/images/img9.png";
import img10 from "../Cleints/images/img10.png";
import img11 from "../Cleints/images/balaji.png";
import img12 from "../Cleints/images/ramjanki.png";
import img13 from "../Cleints/images/ngpl.png";
import img14 from "../Cleints/images/agrocean.png";
import img15 from "../Cleints/images/mandysugars.png";
import img16 from "../Cleints/images/bssail.png";
import img17 from "../Cleints/images/gemsugar.png";
import img18 from "../Cleints/images/ksugar.png";
import img19 from "../Cleints/images/mcpl.png";
import img20 from "../Cleints/images/uctoa_red.png";
import img21 from "../Cleints/images/rsmmhead2.png";
import Bizpetroimg from "./../../assets/bizpetro.avif";


function AllServicesPDF() {

  // ================= TEAM DATA =================
  const teamMembers = [
    {
      name: "Amol Gujar",
      role: "Director & Co-Founder",
      desc: "Visionary leader driving innovation and sustainable growth.",
      img: Amol,
    },
    {
      name: "Amit Wankar",
      role: "Director & Co-Founder",
      desc: "Leads strategy, marketing, and customer engagement.",
      img: Amit,
    },
      {
      name: "Sarang Kuthe",
      role: "Director & Co-Founder",
      desc: "Driving operational excellence and innovation.",
      img: sarang,
    },
    {
      name: "Jitendra Pimpale",
      role: "Director & Co-Founder",
      desc: "Expert in financial strategy and business stability.",
      img: jitendra,
    },
  
    {
      name: "Sameer Pathak",
      role: "Director & Co-Founder",
      desc: "Technical leader building scalable solutions.",
      img: sammer,
    },
  ];

  // ================= TEXT DATA =================
  const aboutCompany = `
Growbean Technologies Pvt. Ltd. is a forward-thinking IT solutions company 
focused on delivering innovative, scalable, and high-performance digital solutions.

We specialize in enterprise systems, automation, software development, and 
smart infrastructure technologies that help businesses optimize operations 
and achieve sustainable growth.

With a strong commitment to quality, innovation, and customer satisfaction, 
we empower organizations to stay competitive in the evolving digital landscape.
`;

const sections = [
  {
    title: "E-Commerce Solutions",
    color: "#0a7cff",
    content: `• Custom website development
• Shopping cart & payment integration
• Secure transactions & fraud protection
• SEO optimized structure
• Responsive UI/UX`,
  },

  {
    title: "System Integration",
    color: "#00a86b",
    content: `• Real-time inventory tracking
• System automation & workflows
• Centralized data management
• Planning & consultation
• Seamless software + hardware integration`,
  },

  {
    title: "ERP Solutions",
    color: "#6c5ce7",
    content: `• Finance & accounting
• HR & payroll management
• Inventory & supply chain
• Manufacturing & operations
• Analytics & reporting`,
  },

  {
    title: "Custom Software Development",
    color: "#f39c12",
    content: `• Web & mobile app development
• Enterprise applications
• API integrations
• Scalable architecture
• UX-focused design`,
  },

  {
    title: "IT Infrastructure",
    color: "#16a085",
    content: `• Network setup & maintenance
• Cloud computing solutions
• Hardware & server support
• Cybersecurity systems
• Data management & backup`,
  },

  {
    title: "Security & Surveillance",
    color: "#e74c3c",
    content: `• CCTV monitoring systems
• Real-time alerts & tracking
• Motion detection & AI monitoring
• Multi-channel alert systems
• 24/7 security infrastructure`,
  },

  {
    title: "ATMS (Advanced Traffic Management)",
    color: "#2980b9",
    content: `• Smart vehicle monitoring
• Real-time insights & analytics
• Automated traffic control
• Centralized dashboard
• Vehicle detection & classification`,
  },

  {
    title: "ITMS (Integrated Traffic Management)",
    color: "#c0392b",
    content: `• Unified system integration
• Real-time monitoring
• Data processing & analytics
• Workflow automation
• Intelligent traffic control`,
  },
];
  const pages = [];
  for (let i = 0; i < sections.length; i += 4) {
    pages.push(sections.slice(i, i + 4));
  }

  // ================= PDF FUNCTION =================
  const downloadPDF = async () => {
    const pdf = new jsPDF("p", "mm", "a4");
    const pageElements = document.querySelectorAll(".pdf-page");

    for (let i = 0; i < pageElements.length; i++) {
      const canvas = await html2canvas(pageElements[i], { scale: 3 });
      const imgData = canvas.toDataURL("image/png");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i !== 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    }

    pdf.save("Growbean_Company_Profile.pdf");
  };

  // ================= STYLES =================
  const pageStyle = {
    width: "800px",
    height: "1120px",
    padding: "40px",
    background: "#f4f7fb",
  };

  const headerStyle = {
    marginBottom: "15px",
    borderBottom: "2px solid #ddd",
  };

  const cardStyle = (color) => ({
    background: "#fff",
    padding: "15px",
    marginBottom: "15px",
    borderLeft: `5px solid ${color}`,
    borderRadius: "8px",
  });
 const clients = [
  img1, img2, img3, img4, img5,
  img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15,
  img16, img17, img18, img19, img20, img21
];
const products = [
  {
    title: "BizPetro Petrol Pump Software",
    desc: `Complete fuel station management system with billing, inventory tracking,
real-time sales monitoring, and reporting.`,
    image: Bizpetroimg,
  },

  {
    title: "Sugar ERP Software",
    desc: `Manage farmer data, procurement, production, inventory, and analytics
in one centralized system.`,
    image: "/images/sugar.jpg", // or import
  },

  {
    title: "Real Estate ERP",
    desc: `Property management, CRM, commission system, and analytics
for real estate businesses.`,
    image: "/images/realestate.jpg",
  },

  {
    title: "Crusher Management System",
    desc: `AI-based system for monitoring production, equipment performance,
and plant efficiency.`,
    image: "/images/crusher.jpg",
  },

  {
    title: "Weighbridge Automation",
    desc: `RFID-based automated weighing system with real-time tracking,
ANPR integration, and reporting.`,
    image: "/images/weighbridge.jpg",
  },
];
  return (
    <div>

      <div style={{ textAlign: "center", margin: "20px" }}>
        <button onClick={downloadPDF}>
          Download Company Profile PDF
        </button>
      </div>

      <div style={{ maxWidth: "820px", margin: "auto" }}>

        <div className="pdf-page" style={pageStyle}>
          <div style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "#1e293b",
            color: "#fff",
            borderRadius: "12px",
          }}>
            <img src={logo} style={{ width: "200px" }} />
            <h2>Growbean Technologies Pvt. Ltd.</h2>
            <p>Company Profile</p>
          </div>
        </div>

        {/* ================= ABOUT ================= */}
        <div className="pdf-page" style={pageStyle}>
          <div style={headerStyle}>
            <h2>About Company</h2>
          </div>
          <div style={cardStyle("#0a7cff")}>
            <p style={{ whiteSpace: "pre-line" }}>
              {aboutCompany}
            </p>
          </div>
        </div>

        <div className="pdf-page" style={pageStyle}>
  <div style={headerStyle}>
    <h2>Our Products</h2>
  </div>

  {products.map((item, index) => (
    <div
      key={index}
      style={{
        display: "flex",
        flexDirection: index % 2 === 0 ? "row" : "row-reverse",
        alignItems: "center",
        gap: "30px",
        marginBottom: "40px",
      }}
    >
      {/* IMAGE */}
      <div style={{ flex: 1 }}>
        <img
          src={item.image}
          style={{
            width: "100%",
            height: "180px",
            objectFit: "cover",
            borderRadius: "12px",
          }}
        />
      </div>

      {/* CONTENT */}
      <div style={{ flex: 1 }}>
        <h3 style={{ marginBottom: "10px" }}>{item.title}</h3>

        <p
          style={{
            color: "#555",
            fontSize: "14px",
            lineHeight: "1.6",
          }}
        >
          {item.desc}
        </p>
      </div>
    </div>
  ))}
</div>

        {/* ================= TEAM ================= */}
        <div className="pdf-page" style={pageStyle}>
          <div style={headerStyle}>
            <h2>Leadership Team</h2>
          </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",         
            gap: "15px",
          }}>
            {teamMembers.map((m, i) => (
              <div key={i} style={{
                background: "#fff",
                padding: "12px",
                borderRadius: "18px",
                textAlign: "center",
              }}>
            <img
             src={m.img}
             style={{
             width: "90px",
             height: "90px",
             borderRadius: "50%",
             objectFit: "cover",    
    objectPosition: "top center", 
             }}/>
                <h4>{m.name}</h4>
                <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                  {m.role}
                </p>
                <p style={{ fontSize: "12px" }}>
                  {m.desc}
                </p>
              </div>
            ))}
          </div>


        </div>
<div className="pdf-page" style={pageStyle}>
  <div style={headerStyle}>
    <h2>Our Esteemed Clients</h2>
  </div>

  <p
    style={{
      textAlign: "center",
      marginBottom: "20px",
      color: "#555",
      fontSize: "14px",
    }}
  >
    Empowering Your Vision, Enriching Our Journey Together
  </p>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(5, 1fr)",
      gap: "20px",
      justifyItems: "center",
    }}
  >
    {clients.map((img, i) => (
      <div
        key={i}
        style={{
          background: "#fff",
          padding: "10px",
          borderRadius: "8px",
          width: "130px",
          height: "80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 3px 8px rgba(0,0,0,0.05)",
        }}
      >
        <img
          src={img}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
          }}
        />
      </div>
    ))}
  </div>
</div>
        {pages.map((group, index) => (
          <div key={index} className="pdf-page" style={pageStyle}>
            <div style={headerStyle}>
              <h3>Services</h3>
            </div>

            {group.map((sec, i) => (
              <div key={i} style={cardStyle(sec.color)}>
                <h4 style={{ color: sec.color }}>{sec.title}</h4>
                <p style={{ whiteSpace: "pre-line" }}>
                  {sec.content}
                </p>
              </div>
            ))}
          </div>
        ))}

      </div>
    </div>
  );
}

export default AllServicesPDF;